import React, { useEffect, useMemo, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userConstants } from "../../constants/ActionTypes";
import { ToastProvider, useToasts } from "react-toast-notifications";
import ApiGateway from "../.././DataServices/DataServices";
import { validate, saveUserShowHome } from "../.././DataServices/Utils";
import Condition from "./Condition";
import { Redirect, Route, Switch, BrowserRouter } from "react-router-dom";
import OpenEye from "../../assets/images/eye_icon.svg";
import CloseEye from "../../assets/images/eye_close_icon.svg";
import Select from "react-select";
import Logo from "../../assets/images/excro-logo.svg";
// import SignUp from "./SignUp";
import { imagePath } from "../../assets/ImagePath";
import GBLVAR from "../../GlobalVariables/GlobalVariables";

var isLogin = Condition();

const SignIn = (props) => {
  // let SITE_KEY = "6Lei3XYoAAAAABpGrGCfH4UdO1QbCVA4lKlKK2N7";
  let SITE_KEY = GBLVAR.SITE_KEY;

  const { auth } = useSelector((state) => state);

  const [resend, setResend] = useState(false);

  const [loginScreen, setLoginScreen] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  const [showVerifyOtp, setShowVerifyOtp] = useState(false);
  const [forgotScreen, setForgotScreen] = useState(false);
  const [PasswordScreen, setPasswordScreen] = useState(false);
  const [otpScreen, SetOtpScreen] = useState(true);
  const handleForgotScreen = () => {
    setLoginScreen(false);
    setForgotScreen(true);
  };

  const optionsMap = {
    isEmailEnabled: { label: "Email", value: "email" },
    isSmsEnabled: { label: "SMS", value: "phone" },
    isTotpEnabled: { label: "Authenticator App", value: "totp" },
  };
  const twoFaCredentials = {
    isEmailEnabled: true,
    isSmsEnabled: false,
    isTotpEnabled: true,
  };
  const enabledOptions = Object.entries(twoFaCredentials)
    .filter(([_, value]) => value === true)
    .map(([key]) => optionsMap[key]);
  const [mfaList, setMfaList] = useState([]);
  const [state, setState] = useState({
    mfaValue: "",
    mfaOtp: "",
    showMfaOtp: false,
    showOTPinput: false,
    showVerifyOtpInput: false,
    merchantId: "",
  });
  const [mfaScreen, setMfaScreen] = useState(true);

  //Dispatch to reducer
  const dispatch = useDispatch();

  //Notification message
  const { addToast } = useToasts();
  const applyToast = (msg, type) => {
    return addToast(msg, { appearance: type });
  };

  const stateChanges = (payload) => {
    return { type: userConstants.REGISTER_REQUEST, payload };
  };

  const updateState = (actionType, value) => (dispatch) => {
    dispatch({ type: actionType, payload: value });
    return Promise.resolve();
  };
  useEffect(() => {
    if (!otpScreen) {
      var display = document.querySelector("#loadtimer");
      submitOtp(60 * 3, display);
    }
  }, [otpScreen]);
  const handleChange = (e) => {
    dispatch(stateChanges({ [e.target.name]: e.target.value }));
  };
  const handleChangeOnOTP = (e) => {
    let regex = /[^0-9]/g;
    if (!regex.test(e.target.value)) {
      dispatch(stateChanges({ [e.target.name]: e.target.value }));
    }
  };
  const loginUser = () => {
    var eRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!auth.email || !eRegex.test(auth.email)) {
      applyToast("Please enter valid email", "error");
    } else if (!auth.login_password) {
      applyToast("Please enter password", "error");
    } else {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(SITE_KEY).then(function (token) {
          if (token) {
            const data = {
              email: auth.email,
              password: auth.login_password,
              recaptcha_token: token,
            };
            setBtnLoader(true);
            ApiGateway.post("/merchant/auth/login", data, function (response) {
              if (response.success) {
                setBtnLoader(false);
                if (response.data?.emailVerified) {
                  saveUserShowHome(response, "from_signin");
                } else if (
                  response.data?.twoFaCredentials?.status === "active"
                ) {
                  setLoginScreen(false);
                  setMfaScreen(true);
                  setState((prev) => ({
                    ...prev,
                    merchantId: response.data?.merchantId,
                  }));
                  const credentials = Object.entries(
                    response.data?.twoFaCredentials || {}
                  );

                  const filtered = credentials.filter(
                    ([_, value]) => value === true
                  );

                  const mapped = filtered.map(([key]) => optionsMap[key]);

                  const finalList = mapped.filter((item) => item !== undefined);

                  setMfaList(finalList);
                } else {
                  SetOtpScreen(false);
                  applyToast(response.message, "success");
                }
              } else {
                applyToast(response.message, "error");
                setBtnLoader(false);
              }
            });
          }
        });
      });
    }
  };

  const { match, location } = props;

  if (location.pathname === "/signin") {
    if (isLogin) {
      return <Redirect to={"/dashboard"} />;
    }
  }

  const handleEnter = (event) => {
    if (event.key === "Enter") {
      loginUser();
    }
  };
  const handleShowPassword = () => {
    var payload = { showPassword: !auth.showPassword };
    dispatch(stateChanges(payload));
  };

  const verifyOtp = () => {
    var emailOTP = auth.email_otp;
    var mobileOTP = auth.otp;
    if (emailOTP === "" || emailOTP.length < 6 || isNaN(emailOTP)) {
      applyToast("Please enter valid email verification code ");
    } /* else if (mobileOTP === "" || mobileOTP.length < 6 || isNaN(mobileOTP)) {
            applyToast("Please enter valid mobile verification code");
        } */ else {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(SITE_KEY).then(function (token) {
          if (token) {
            var data = {
              email: auth.email,
              verification_code: emailOTP,
              // phone_otp: mobileOTP,
              last_login: {
                from: "web",
              },
              recaptcha_token: token,
            };
            ApiGateway.post(
              "/merchant/auth/reg-verify",
              data,
              function (response) {
                if (response.success) {
                  applyToast(response.message, "success");
                  saveUserShowHome(response, "from_otp");
                } else {
                  applyToast(response.message, "error");
                }
              }
            );
          } else {
            applyToast("Captcha Verification failed.");
          }
        });
      });
    }
  };

  const resendOtp = (id) => {
    window.grecaptcha &&
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(SITE_KEY).then(function (token) {
          if (token) {
            var data;
            if (id == "email") {
              data = {
                email: auth.email,
                recaptcha_token: token,
              };
            } else {
              data = {
                mobile: auth.email,
                recaptcha_token: token,
              };
            }
            ApiGateway.post(
              `/merchant/auth/reg-resend-otp`,
              data,
              function (response) {
                if (response.success === true) {
                  applyToast(response.message, "success");
                  var display = document.querySelector("#loadtimer");
                  submitOtp(60 * 3, display);
                } else {
                  applyToast(response.message, "error");
                }
              }
            );
          } else {
            applyToast("Captcha Verification failed.", "error");
          }
        });
      });
    setResend(false);
  };
  const submitOtp = (duration, display) => {
    var timer = duration,
      minutes,
      seconds;
    var loadtimer = setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      display.textContent = minutes + ":" + seconds;
      if (--timer < 0) {
        clearInterval(loadtimer);
        setResend(true);
      }
    }, 1000);
  };

  const handleKeyEvent = (e) => {
    var theEvent = e || window.event;
    if (theEvent.type === "paste") {
      key = e.clipboardData.getData("text/plain");
    } else {
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    var regex = /^[0-9]+$/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
  };
  const handleVerfiyOtp = (event) => {
    if (event.key === "Enter") {
      verifyOtp();
    }
  };
  const handleShowEmailPassword = () => {
    var payload = { showEmailPassword: !auth.showEmailPassword };
    dispatch(stateChanges(payload));
  };
  const loginScreenTrue = () => {
    // history.push("/signin")
    SetOtpScreen(true);
  };

  const sendEmailOtp = () => {
    var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!auth.forget_email || !emailRegex.test(auth.forget_email)) {
      applyToast("Please Enter Valid Email ID", "error");
    } else {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(SITE_KEY).then(function (token) {
          if (token) {
            let data = {
              email: auth.forget_email,
              recaptcha_token: token,
            };
            ApiGateway.post(
              "/merchant/auth/forget-password",
              data,
              (response) => {
                if (response.success) {
                  applyToast(response.message, "success");
                  setShowVerifyOtp(true);
                } else {
                  applyToast(response.message, "error");
                }
              }
            );
          }
        });
      });
    }
  };

  const verifyEmailOtp = () => {
    if (!auth.verify_email_otp) {
      applyToast("Please Enter Valid OTP", "error");
    } else if (auth.verify_email_otp.length !== 6) {
      applyToast("Please Enter 6 digits OTP", "error");
    } else {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(SITE_KEY).then(function (token) {
          if (token) {
            let data = {
              email: auth.forget_email,
              otp: auth.verify_email_otp,
              recaptcha_token: token,
            };
            ApiGateway.post("/merchant/auth/verify-otp", data, (response) => {
              if (response.success) {
                applyToast(response.message, "success");
                dispatch(stateChanges({ otpToken: response?.data?.token }));
                setPasswordScreen(true);
                setShowVerifyOtp(false);
              } else {
                applyToast(response.message, "error");
              }
            });
          }
        });
      });
    }
  };

  const createNewPassword = () => {
    if (
      !auth.newPassword.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
      )
    ) {
      applyToast("Password should contain 8 Characters", "error");
    } else if (auth.confirmNewPAssword !== auth.newPassword) {
      applyToast("Confirm Password does not match New Password", "error");
    } else {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(SITE_KEY).then(function (token) {
          if (token) {
            let data = {
              email: auth.forget_email,
              token: auth.otpToken,
              newPassword: auth.newPassword,
              confirmPassword: auth.confirmNewPAssword,
              recaptcha_token: token,
            };
            ApiGateway.post(
              "/merchant/auth/reset-password",
              data,
              (response) => {
                if (response.success) {
                  applyToast(response.message, "success");
                  setLoginScreen(true);
                  setShowVerifyOtp(false);
                  setForgotScreen(false);
                  setPasswordScreen(false);
                  dispatch(
                    updateState(userConstants.REGISTER_REQUEST, {
                      forget_email: "",
                      verify_email_otp: "",
                      newPassword: "",
                      confirmNewPAssword: "",
                    })
                  );
                  dispatch(stateChanges({ login_password: "" }));
                } else {
                  applyToast(response.message, "error");
                }
              }
            );
          }
        });
      });
    }
  };

  const handleNewPassword = () => {
    var payload = { showcreatePassword: !auth?.showcreatePassword };
    dispatch(stateChanges(payload));
  };
  const handleConfimrNewPassword = () => {
    var payload = {
      showConfirmcreatePassword: !auth?.showConfirmcreatePassword,
    };
    dispatch(stateChanges(payload));
  };

  const showEmailOtpScreen = () => {
    var payload = { showEmailOtp: !auth?.showEmailOtp };
    dispatch(stateChanges(payload));
  };
  const handleSelectMfa = (e) => {
    setState((prev) => ({
      ...prev,
      mfaValue: e ? e.value : null,
      showVerifyOtpInput: false,
    }));
  };

  const handleShowMFAOtp = () => {
    setState((prev) => ({
      ...prev,
      showMfaOtp: !state.showMfaOtp,
    }));
  };

  const sendMfaOtp = (isResend = false) => {
    if (!isResend) {
      setBtnLoader(true);
    }
    ApiGateway.get(
      `/merchant/auth/send-${state?.mfaValue}-verify-otp/${state?.merchantId}`,
      (response) => {
        if (response.success) {
          setBtnLoader(false);
          setState((prev) => ({
            ...prev,
            mfaOtp: "",
            showVerifyOtpInput: true,
          }));
          applyToast(response.message);
        } else {
          setBtnLoader(false);
          applyToast(response.message);
        }
      }
    );
  };

  const sendMfaVerifyTOtp = () => {
    setState((prev) => ({
      ...prev,
      mfaOtp: "",
      showVerifyOtpInput: true,
    }));
  };

  const mfaLogin = () => {
    if (!state?.showVerifyOtpInput) {
      applyToast("Please Select MFA Type", "error");
      return;
    }
    if (!state.mfaOtp || state.mfaOtp.length < 6) {
      applyToast("Please enter valid OTP", "error");
      return;
    }

    const data = {};
    if (state?.mfaValue === "email") {
      data.email = auth.email;
      data.otp = state.mfaOtp;
    }
    if (state?.mfaValue === "phone") {
      data.email = auth.email;
      data.otp = state.mfaOtp;
    }
    if (state?.mfaValue === "totp") {
      data.email = auth.email;
      data.totp = state.mfaOtp;
    }
    setBtnLoader(true);
    ApiGateway.post(`/merchant/auth/two-fa-login`, data, (response) => {
      if (response.success) {
        setBtnLoader(false);
        applyToast(response.message);
        saveUserShowHome(response, "from_signin");
      } else {
        setBtnLoader(false);
        applyToast(response.message);
      }
    });
  };

  const handleEnterMfaLogin = (event) => {
    if (event.key === "Enter") {
      mfaLogin();
    }
  };
  const handleMfaPassword = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handlebackToLogin = () => {
    setLoginScreen(true);
    setBtnLoader(false);
    setState((prev) => ({
      ...prev,
      mfaOtp: "",
      merchantId: "",
      showVerifyOtpInput: false,
      mfaValue: "",
    }));
  };
  const forgotPassToLogin = () => {
    setLoginScreen(true);
    setShowVerifyOtp(false);
    setForgotScreen(false);
    setPasswordScreen(false);
    dispatch(
      updateState(userConstants.REGISTER_REQUEST, {
        forget_email: "",
        verify_email_otp: "",
        newPassword: "",
        confirmNewPAssword: "",
      })
    );
  };
  return (
    <>
      {otpScreen ? (
        <>
          <div className="login_body">
            <div className="login_wrapper">
              <div className="center_tab">
                {loginScreen ? (
                  <div className="center_login p-b-30">
                    <div className="flex-center mb-10">
                      <img src={Logo} alt="logo" style={{ height: "58px" }} />
                    </div>
                    <div className="login_title">Login</div>
                    <div className="welcome_back_con">Welcome</div>
                    <div className="from_wrapper">
                      <label>Email:</label>
                      <input
                        type="tel"
                        placeholder="Enter your email"
                        className="form-control"
                        name="email"
                        value={auth.email}
                        onChange={handleChange}
                        onKeyDown={handleEnter}
                      />
                    </div>
                    <div className="from_wrapper">
                      <label>Password:</label>
                      <input
                        type={auth.showPassword ? "text" : "password"}
                        placeholder="Enter your password"
                        className="form-control"
                        name="login_password"
                        value={auth.login_password}
                        onChange={handleChange}
                        onKeyDown={handleEnter}
                      />
                      <div className="login_eye" onClick={handleShowPassword}>
                        {auth.showPassword === false ? (
                          <img src={CloseEye} />
                        ) : (
                          <img src={OpenEye} />
                        )}
                      </div>
                    </div>

                    <span
                      className="btn_submit"
                      onClick={!btnLoader ? loginUser : null}
                      onKeyDown={handleEnter}
                    >
                      {btnLoader ? (
                        <span className="btn-loader"></span>
                      ) : (
                        "Submit"
                      )}
                    </span>

                    <div className="already_having_account">
                      <a className="pink_clr" onClick={handleForgotScreen}>
                        Forgot Password
                      </a>
                    </div>
                  </div>
                ) : forgotScreen ? (
                  <div className="center_login p-b-30">
                    <div className="flex-center mb-10">
                      <img src={Logo} alt="logo" style={{ height: "58px" }} />
                    </div>
                    {PasswordScreen ? (
                      <div className="login_title">Create New Password</div>
                    ) : (
                      <div className="login_title">Forgot Password</div>
                    )}
                    <div className="welcome_back_con">Welcome</div>
                    <div className="from_wrapper">
                      <label>Enter Email:</label>
                      <input
                        type="email"
                        placeholder="Enter your email"
                        className="form-control"
                        name="forget_email"
                        value={auth.forget_email}
                        onChange={handleChange}
                      />
                    </div>

                    {showVerifyOtp ? (
                      <>
                        <div className="from_wrapper">
                          <label>Enter OTP:</label>
                          <input
                            type={auth.showEmailOtp ? "text" : "password"}
                            placeholder="Enter your OTP"
                            className="form-control"
                            name="verify_email_otp"
                            value={auth.verify_email_otp}
                            onChange={handleChangeOnOTP}
                            maxLength={6}
                          />
                          <div
                            className="login_eye"
                            onClick={showEmailOtpScreen}
                          >
                            {auth.showEmailOtp === false ? (
                              <img src={CloseEye} alt="close" />
                            ) : (
                              <img src={OpenEye} alt="open" />
                            )}
                          </div>
                          {/* {resendForgotOtp === true ? (
                            <span
                              className="login-form-forgot"
                              onClick={() => resendOtp("email")}
                            >
                              Resend
                            </span>
                          ) : (
                            ""
                          )} */}
                        </div>
                        <>
                          <span
                            className="pink_clr"
                            onClick={forgotPassToLogin}
                          >
                            Back To Login?
                          </span>
                          <span className="btn_submit" onClick={verifyEmailOtp}>
                            Verify OTP
                          </span>
                        </>
                      </>
                    ) : !PasswordScreen ? (
                      <>
                        <span className="pink_clr" onClick={forgotPassToLogin}>
                          Back To Login?
                        </span>

                        <span className="btn_submit" onClick={sendEmailOtp}>
                          Send OTP
                        </span>
                      </>
                    ) : (
                      ""
                    )}
                    {PasswordScreen ? (
                      <>
                        <div className="from_wrapper">
                          <label>New Password:</label>
                          <input
                            // type={auth.showcreatePassword ? "text" : "password"}
                            type="text"
                            placeholder="Enter New Password"
                            className={`form-control ${
                              auth.showcreatePassword ? "" : "masked"
                            }`}
                            name="newPassword"
                            value={auth.newPassword}
                            onChange={handleChange}
                          />
                          <div
                            className="login_eye"
                            onClick={handleNewPassword}
                          >
                            {auth.showcreatePassword === false ? (
                              <img src={CloseEye} alt="close" />
                            ) : (
                              <img src={OpenEye} alt="open" />
                            )}
                          </div>
                        </div>
                        <div className="prefix_hint">
                          Password should contain minimum 8 Characters.
                        </div>
                        <div className="from_wrapper">
                          <label>Confirm Password:</label>
                          <input
                            type="text"
                            placeholder="Enter your password"
                            className={`form-control ${
                              auth.showConfirmcreatePassword ? "" : "masked"
                            }`}
                            name="confirmNewPAssword"
                            value={auth.confirmNewPAssword}
                            onChange={handleChange}
                          />
                          <div
                            className="login_eye"
                            onClick={handleConfimrNewPassword}
                          >
                            {auth.showConfirmcreatePassword === true ? (
                              <img src={CloseEye} alt="close" />
                            ) : (
                              <img src={OpenEye} alt="open" />
                            )}
                          </div>
                        </div>
                        <span className="pink_clr" onClick={forgotPassToLogin}>
                          Back To Login?
                        </span>
                        <span
                          className="btn_submit"
                          onClick={createNewPassword}
                        >
                          Create Password
                        </span>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                ) : mfaScreen ? (
                  <div className="center_login p-b-30">
                    <div className="flex-center mb-10">
                      <img src={Logo} alt="logo" style={{ height: "58px" }} />
                    </div>
                    <div className="login_title">Login </div>
                    <div className="welcome_back_con">Welcome</div>
                    <div className="from_wrapper">
                      <label>Select MFA:</label>
                      <Select
                        className="selectpicker"
                        options={mfaList}
                        onChange={handleSelectMfa}
                        isClearable
                      />
                    </div>

                    {state?.showVerifyOtpInput && (
                      <>
                        <div className="from_wrapper">
                          <label>OTP:</label>
                          <input
                            type={state.showMfaOtp ? "text" : "password"}
                            placeholder="Enter your OTP"
                            className="form-control"
                            name="mfaOtp"
                            value={state.mfaOtp}
                            onChange={handleMfaPassword}
                            onKeyDown={handleEnterMfaLogin}
                            maxLength={6}
                            onKeyPress={(e) => validate(e)}
                          />
                          <div className="login_eye" onClick={handleShowMFAOtp}>
                            {state.showMfaOtp ? (
                              <img src={OpenEye} alt="open" />
                            ) : (
                              <img src={CloseEye} alt="close" />
                            )}
                          </div>
                        </div>
                        {state?.mfaValue === "totp" ? (
                          ""
                        ) : (
                          <span
                            className="resend-otp"
                            onClick={() => sendMfaOtp(true)}
                          >
                            Resend OTP
                          </span>
                        )}
                      </>
                    )}

                    {!state?.showVerifyOtpInput &&
                    (state?.mfaValue === "email" ||
                      state?.mfaValue === "phone") ? (
                      <>
                        {/*send otp for email and sms*/}
                        <span
                          className="btn_submit"
                          onClick={!btnLoader ? () => sendMfaOtp(true) : null}
                        >
                          {btnLoader ? (
                            <span className="btn-loader"></span>
                          ) : (
                            "Submit"
                          )}
                        </span>
                      </>
                    ) : !state?.showVerifyOtpInput &&
                      state?.mfaValue === "totp" ? (
                      <>
                        {/*condition to show only otp section for Totp*/}
                        <span
                          className="btn_submit"
                          onClick={!btnLoader ? sendMfaVerifyTOtp : null}
                        >
                          {btnLoader ? (
                            <span className="btn-loader"></span>
                          ) : (
                            "Submit"
                          )}
                        </span>
                      </>
                    ) : (
                      <>
                        {/*MFA Login submit api*/}
                        <span
                          className="btn_submit"
                          onClick={!btnLoader ? mfaLogin : null}
                        >
                          {btnLoader ? (
                            <span className="btn-loader"></span>
                          ) : (
                            "Submit"
                          )}
                        </span>
                      </>
                    )}

                    <div className="already_having_account">
                      <span className="pink_clr" onClick={handlebackToLogin}>
                        Back to Login?
                      </span>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="signup-wrap">
            <div className="left_login">
              <div className="left_content_login">
                <div className="left_content_top">
                  {/* <img
                    className="logo_desktop"
                    src={imagePath("./logo.svg").default}
                  />
                  <img
                    className="logo_mobile"
                    src={imagePath("./logo.svg").default}
                  /> */}
                  <label className="left_logo">Paykraft</label>
                </div>
                <div className="lgoin_right_wrap">
                  <div className="left_content_middle">
                    <div className="left_content_subheading">
                      <label className="left_content_heading">
                        Why choose Paykraft?
                      </label>
                    </div>
                    <div className="left_content_subheading_list">
                      <ul className="left_list">
                        <li className="list_content">
                          <img
                            src={imagePath("./banking_api.png").default}
                            alt=""
                            className="list_logo"
                          />
                          Fund Transfer
                        </li>
                        <li className="list_content">
                          <img
                            src={imagePath("./upi-new.png").default}
                            alt=""
                            className="list_logo"
                          />
                          UPI
                        </li>
                        <li className="list_content">
                          <img
                            src={imagePath("./payment_api.png").default}
                            alt=""
                            className="list_logo"
                          />
                          Payouts
                        </li>
                        <li className="list_content">
                          <img
                            src={imagePath("./vpa_api.png").default}
                            alt=""
                            className="list_logo"
                          />
                          Virtual Account
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="login_right">
              <div className="login_link hidden-xs">
                <label>Already have an account?</label>

                <button
                  type="submit"
                  className="top_right_btn"
                  onClick={loginScreenTrue}
                >
                  Sign In
                </button>
              </div>
              <div className="lgoin_right_wrap">
                <div className="login_content">
                  <div className="login_inner_cont">
                    <div className="signup_form">
                      <div className="col-xs-12 p-0" id="password_wrapper">
                        {/* <div className="form_wrapper_login">
                                                <label htmlFor="">Mobile OTP</label>
                                                {resend === true ? <span className="login-form-forgot" onClick={() => resendOtp("sms")}>Resend</span> : ""}

                                                <input type={auth.showPassword ? "text" : "password"} className="form_control" name="otp" value={auth.otp || ""} onChange={handleChange} 
                                                onKeyPress={handleKeyEvent} onPaste={handlePaste} onKeyDown={handleVerfiyOtp}/>
                                                <div className="eye" onClick={handleShowPassword}>
                                                {auth.showPassword === false ? <img src={CloseEye}/> :  <img src={OpenEye}/>}
                                                </div>
                                                <span className="sendotptext">
                                                We have sent you an verification code to 
                                                {auth.phone === undefined
                                                ? "your registered mobile number"
                                                : " +91" + auth.phone}                   
                                                </span>
                                                </div> */}
                        <div className="login_header">
                          <h1>OTP Verification</h1>
                          <div className="head_content">Enter your OTP</div>
                        </div>
                        <div className="form_wrapper_login">
                          <label htmlFor="">Email OTP</label>
                          {resend === true ? (
                            <span
                              className="login-form-forgot"
                              onClick={() => resendOtp("email")}
                            >
                              Resend
                            </span>
                          ) : (
                            ""
                          )}
                          <input
                            type={auth.showEmailPassword ? "text" : "password"}
                            className="form_control"
                            name="email_otp"
                            value={auth.email_otp || ""}
                            onChange={handleChange}
                            onKeyPress={handleKeyEvent}
                            onPaste={handlePaste}
                            onKeyDown={handleVerfiyOtp}
                          />
                          <div
                            className="eye"
                            onClick={handleShowEmailPassword}
                          >
                            {auth.showEmailPassword === false ? (
                              <img src={CloseEye} alt="close" />
                            ) : (
                              <img src={OpenEye} alt="open" />
                            )}
                          </div>
                          <span className="sendotptext">
                            We have sent you an verification code to
                            {auth.email}
                          </span>
                        </div>
                      </div>
                      <div className="resend_text">
                        <span className="sendotptext otp-timer">
                          <span className="otp-timer">Resend in - </span>
                          <span id="loadtimer" className="ttp_time">
                            03:00
                          </span>
                        </span>
                      </div>
                      <div className="forgotpwd_submit_btn">
                        <a
                          className="verify_btn"
                          onClick={verifyOtp}
                          onKeyDown={handleVerfiyOtp}
                        >
                          Verify OTP
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SignIn;
